import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";
import { TitleStrategy } from "@angular/router";
import { BRAND_CONFIG, BrandConfig } from "./brand-config";
import { BrandTitleStrategy } from "./brand-title.strategy";
import { BrandService } from "./brand.service";

/**
 * Registers all branding-related providers (BRAND_CONFIG, BrandService bootstrap, BrandTitleStrategy).
 * Use in `app.config.ts` providers array.
 * @param brand - The brand config to use.
 * @returns The environment providers.
 */
export function provideBranding(brand: BrandConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: BRAND_CONFIG, useValue: brand },
    provideAppInitializer(() => {
      inject(BrandService);
    }),
    { provide: TitleStrategy, useClass: BrandTitleStrategy },
  ]);
}
